'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsSubmenu", {
    enumerable: true,
    get: function() {
        return useIsSubmenu;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const _menuContext = require("../contexts/menuContext");
const _menuListContext = require("../contexts/menuListContext");
function useIsSubmenu() {
    const menuContextValue = (0, _menuContext.useMenuContext_unstable)((context)=>context.isSubmenu);
    const hasMenuListContext = (0, _reactcontextselector.useHasParentContext)(_menuListContext.MenuListContext);
    return menuContextValue || hasMenuListContext;
}
